<template>
  <v-dialog v-model="show" width="600">
    <v-card>
      <v-card-title class="third white--text">
        Réapprovisionnement des stocks
      </v-card-title>
      <v-card-text class="mt-4 pa-0">
        <div class="px-6">
          <p v-if="!isSingleUpdate">Le participant {{ selectedParticipant.fullname }} sera éliminé de {{ totalRecurringSessions }} sessions, dont {{ totalStockToRestore }} ont déjà eu lieu.</p>
          <p>Vous souhaitez réapprovisionner {{ isSingleUpdate ? '1' : totalStockToRestore }} unités du stock du contrat?</p>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn outlined rounded small class="third--text" :disabled="loading" @click="closeModal">
          <v-icon>mdi-arrow-u-left-top</v-icon>
          Annuler
        </v-btn>
        <v-btn outlined rounded small class="third--text" :loading="loading" @click="participantRemoval">
          <v-icon>mdi-minus-circle-outline</v-icon>
          Retirer sans stock
        </v-btn>
        <v-btn outlined rounded small class="third--text" :loading="loading" @click="stockRestauration">
          <v-icon>mdi-plus-circle-outline</v-icon>
          Réapprovisionner
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from '@vue/composition-api';
import { sendNotification } from '@/helpers/utils';
import { restoreStock } from '@/helpers/request';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedParticipant: {
      type: Object,
      default: () => {}
    },
    session: {
      type: Object,
      default: () => {}
    },
    typeOfupdate: {
      type: String,
      default: ''
    },
    totalRecurringSessions: {
      type: Number,
      default: 0
    },
    totalStockToRestore: {
      type: Number,
      default: 0
    }
  },
  setup (props, context) {
    const loading = ref(false);

    const isSingleUpdate = computed(() => props.typeOfupdate === 'SINGLE');

    const closeModal = () => {
      context.emit('closeModal');
    };

    const computeSessionBody = () => {
      return {
        id: props.session.id,
        start_time: props.session.start_time,
        end_time: props.session.end_time,
        recurring_uuid: props.session.recurring_uuid,
        end_recurring_date: props.session.end_recurring_date,
      }
    }

    const stockRestauration = async () => {
      loading.value = true;
      const session = computeSessionBody();
      const response = await restoreStock(session, props.typeOfupdate, props.selectedParticipant.participant, props.selectedParticipant.contract_number);
      sendNotification(response.success ? 'success' : 'error', response.message);
      loading.value = false;
      closeModal();
    };

    const participantRemoval = async () => {
      context.emit('participantRemoval');
    };

    return { closeModal, loading, isSingleUpdate, stockRestauration, participantRemoval };
  }
};
</script>
